import React, { useRef } from 'react';
import { Card, Field, TextField, SaveButton, useSection } from '../AdminUI';
import { Plus, Trash2, Upload } from 'lucide-react';

function fileToDataUrl(file, maxSize = 400) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      const img = new Image();
      img.onerror = reject;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let { width, height } = img;
        if (width > maxSize || height > maxSize) {
          const s = Math.min(maxSize / width, maxSize / height);
          width = Math.round(width * s);
          height = Math.round(height * s);
        }
        canvas.width = width; canvas.height = height;
        canvas.getContext('2d').drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL('image/png', 0.9));
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}

function LogoUpload({ value, onChange }) {
  const ref = useRef(null);
  const handle = async (e) => {
    const f = e.target.files?.[0]; if (!f) return;
    onChange(await fileToDataUrl(f, 200));
  };
  return (
    <div className="flex items-center gap-2">
      <div className="w-12 h-12 rounded-md bg-zinc-950 border border-zinc-800 flex items-center justify-center overflow-hidden">
        {value ? <img src={value} alt="" className="max-w-full max-h-full object-contain" /> : <span className="text-zinc-600 text-[9px]">no logo</span>}
      </div>
      <input ref={ref} type="file" accept="image/*" onChange={handle} className="hidden" />
      <button type="button" onClick={() => ref.current?.click()} className="h-8 px-2.5 rounded-md bg-zinc-900 hover:bg-zinc-800 border border-zinc-800 text-zinc-200 text-xs flex items-center gap-1.5"><Upload size={12} /> Upload</button>
      {value && <button type="button" onClick={() => onChange('')} className="h-8 w-8 rounded-md bg-red-600/15 text-red-300 border border-red-900/40 flex items-center justify-center"><Trash2 size={12} /></button>}
    </div>
  );
}

export default function InPlaySection() {
  const [local, setLocal, save] = useSection('inPlayMatches');
  const upd = (i, k, v) => setLocal(local.map((m, idx) => idx === i ? { ...m, [k]: v } : m));
  const remove = (i) => setLocal(local.filter((_, idx) => idx !== i));
  const add = () => setLocal([...local, { id: Date.now(), name: 'New Platform', type: 'B2C White Label', tags: '', rating: '5.0', reviews: '0', logo: '', visitUrl: '' }]);

  return (
    <Card title="GET ID Platforms" desc="Platforms shown in the GET ID table on homepage. Upload logo + add visit URL." footer={<SaveButton onClick={save} />}>
      <div className="space-y-3">
        {(local || []).map((m, i) => (
          <div key={m.id} className="rounded-lg border border-zinc-800 bg-zinc-900/40 p-3">
            <div className="flex items-center justify-between mb-2">
              <span className="text-zinc-300 text-sm font-semibold">Platform #{i + 1}</span>
              <button onClick={() => remove(i)} className="h-7 px-2 rounded-md bg-red-600/15 text-red-300 text-xs border border-red-900/40 flex items-center gap-1"><Trash2 size={12} /> Remove</button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
              <Field label="Name"><TextField value={m.name} onChange={(v) => upd(i, 'name', v)} /></Field>
              <Field label="Type"><TextField value={m.type} onChange={(v) => upd(i, 'type', v)} /></Field>
              <Field label="Tags / Features"><TextField value={m.tags || ''} onChange={(v) => upd(i, 'tags', v)} /></Field>
              <Field label="Rating"><TextField value={m.rating} onChange={(v) => upd(i, 'rating', v)} /></Field>
              <Field label="Reviews count"><TextField value={m.reviews} onChange={(v) => upd(i, 'reviews', v)} /></Field>
              <Field label="Visit Site URL"><TextField value={m.visitUrl || ''} onChange={(v) => upd(i, 'visitUrl', v)} placeholder="https://platform.com" /></Field>
              <div className="md:col-span-3">
                <label className="text-xs font-semibold text-zinc-300 mb-1.5 block">Brand Logo</label>
                <LogoUpload value={m.logo || ''} onChange={(v) => upd(i, 'logo', v)} />
              </div>
            </div>
          </div>
        ))}
        <button onClick={add} className="w-full h-10 rounded-md border border-dashed border-zinc-700 text-zinc-300 text-sm flex items-center justify-center gap-1.5"><Plus size={14} /> Add Platform</button>
      </div>
    </Card>
  );
}
